{
  "de": {
    "ai": {
      "assistant": {
        "all_projects": "Alle Projekte",
        "cap": {
          "action": "Neue Konversation starten",
          "message": "Sie haben das Konversationslimit erreicht."
        },
        "empty_state": {
          "subtitle": "Fragen Sie mich alles über Ihre Kunden",
          "title": "Wie kann ich Ihnen helfen?"
        },
        "errors": {
          "budget_reached": "Das monatliche KI-Budget für diesen Arbeitsbereich wurde erreicht. Wenden Sie sich an einen Administrator, um das Limit zu erhöhen.",
          "generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
        },
        "history": {
          "empty": "Noch keine früheren Konversationen",
          "title": "Frühere Konversationen"
        },
        "input": {
          "disclaimer": "Ergebnisse können ungenau sein. Überprüfen Sie wichtige Informationen immer.",
          "hint": "Enter zum Senden · Shift+Enter für neue Zeile",
          "placeholder": "Fragen Sie zu Ihren Kunden..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Wie richte ich Benachrichtigungen ein?",
          "help_project_settings": "Wo finde ich die Projekteinstellungen?",
          "open_decisions": "Welche Entscheidungen sind noch offen?",
          "unassigned_units": "Welche Einheiten haben noch keinen Kunden?"
        },
        "support_cta": {
          "action": "Support kontaktieren",
          "prompt": "Nicht die Antwort, die Sie gesucht haben?"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Budget",
          "description": "Monatliche Kostenobergrenze für die KI-Nutzung (Testphase). Wird basierend auf der Token-Nutzung in allen Konversationen dieses Monats neu berechnet.",
          "save": "Speichern",
          "title": "Monatliches Budget",
          "usage_label": "Diesen Monat verbraucht"
        },
        "description": "Konfiguration der KI-Funktionen in Ihrem Arbeitsbereich.",
        "title": "KI-Einstellungen"
      }
    }
  }
}
